import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        color: {
            type: String,
            required: false,
        },
        rotate: {
            type: String,
            required: false,
        },
        scale: {
            type: String,
            required: false,
        },
        hover: {
            type: Boolean,
            default: false,
        },
        noninteractable: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const hoverStatus = computed(() => ({
            hovered: props.hover,
            normal: !props.hover,
        }));
        return { hoverStatus };
    },
});
